<template>
    <div class="all-view">
        <div class="main-page-title">

            <div style="width: 35px;height: 35px;position: relative">
                <img v-if="headerImg" :src="headerImg" style="width: 35px;height: 35px;border-radius: 4px;">
                <img v-else src="../../img/default_img.png" style="width: 35px;height: 35px;border-radius: 4px;">
            </div>

            <div style="color: #dddddd;display: flex;flex-direction: column;align-items: flex-start;padding-left: 15px;">
                <div>
                    <span style="color: #FFFFFF;font-weight: bold">{{userName}}</span>
                    <span style="font-size: 11px;margin-left: 15px;">uid {{uid}}</span>
                </div>
                <div style="font-size: 11px;">
                    <span style=""><van-icon name="balance-o" /> ￥{{qlb}}</span>
                    <span style="margin-left: 15px;"><van-icon name="phone-o" /> {{tel || '未绑定'}}</span>
                </div>
            </div>

            <div @click="close" style="width: 30px;height: 30px;position: absolute;right: 2px;top: 2px;box-sizing: border-box;">
                <img src="../../img/close.png" style="width: 30px;height: 30px;">
            </div>

        </div>

        <div class="main-body">
            <div class="menu-view">
                <van-grid :border="true" :column-num="4">
                    <van-grid-item @click="openGiftPage">
                        <div class="menu-img-view">
                            <img src="../../img/menu/gift2.png" style="width: 25px;height: 25px;">
                        </div>
                        <span style="font-size: 12px;color: #444444;">礼包领取</span>
                    </van-grid-item>

<!--                    <van-grid-item @click="openExpensePage">-->
<!--                        <div class="menu-img-view">-->
<!--                            <img src="../../img/menu/record.png" style="width: 25px;height: 25px;">-->
<!--                        </div>-->
<!--                        <span style="font-size: 12px;color: #444444;">消费查询</span>-->
<!--                    </van-grid-item>-->
                    <van-grid-item @click="openContentList('2')">
                        <div class="menu-img-view">
                            <!--                            <img src="../../img/menu/record.png" style="width: 30px;height: 30px;">-->
                            <svg t="1721616545631" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9333" width="20" height="20">
                                <path d="M819.079933 746.283867v122.859417H204.782848v-122.859417l307.148542-215.00398 307.148543 215.00398zM204.782848 290.879642v-122.859417h614.297085v122.859417L511.93139 516.121907 204.782848 290.879642z" fill="#F8D382" p-id="9334"></path>
                                <path d="M921.46278 51.277186A48.399164 48.399164 0 0 0 870.271357 0.085762H153.591424A48.399164 48.399164 0 0 0 102.4 51.277186v245.718834a9.972355 9.972355 0 0 0 10.238285 10.238285l307.148542 204.765695L122.87657 727.00398l-10.238285 10.238285C102.4 737.242265 102.4 757.984764 102.4 767.957119v204.765695A48.399164 48.399164 0 0 0 153.591424 1023.914238h716.679933a48.399164 48.399164 0 0 0 51.191423-51.191424V757.984764c0-20.47657-10.238285-30.714854-20.476569-30.714855L604.075953 512l296.910258-215.00398c10.238285 0 20.47657-20.47657 20.476569-30.714854z m-102.382847 747.394787v122.859417H204.782848v-122.859417l307.148542-215.00398zM204.782848 225.328027V102.46861h614.297085v122.859417L511.93139 450.570291z m0 0" fill="#FEB30D" p-id="9335"></path>
                            </svg>
                        </div>
                        <span style="font-size: 12px;color: #444444;">充值活动</span>
                    </van-grid-item>
                    <van-grid-item @click="openContentList('1')">
                        <div class="menu-img-view">
                            <svg t="1721616722412" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17823" width="20" height="20">
                                <path d="M705.8 256.4c-13.8 0-25-11.2-25-25V70.8H545.2v160.6c0 13.8-11.2 25-25 25s-25-11.2-25-25V45.8c0-13.8 11.2-25 25-25h185.6c13.8 0 25 11.2 25 25v185.6c0 13.8-11.2 25-25 25z" fill="#E99020" p-id="17824"></path>
                                <path d="M705.8 256.4c-5.7 0-11.4-1.9-16-5.8L613 186.2l-76.8 64.3c-10.6 8.9-26.3 7.5-35.2-3.1-8.9-10.6-7.5-26.3 3.1-35.2l92.8-77.8c9.3-7.8 22.8-7.8 32.1 0l92.8 77.8c10.6 8.9 12 24.6 3.1 35.2-4.9 5.9-12 9-19.1 9z" fill="#E99020" p-id="17825"></path>
                                <path d="M877.4 991.3H171.8c-49.1 0-89-39.9-89-89V109.8c0-49.1 39.9-89 89-89h705.6c49.1 0 89 39.9 89 89v792.4c0 49.1-39.9 89.1-89 89.1zM171.8 70.8c-21.5 0-39 17.5-39 39v792.4c0 21.5 17.5 39 39 39h705.6c21.5 0 39-17.5 39-39V109.8c0-21.5-17.5-39-39-39H171.8z" fill="#707070" p-id="17826"></path>
                                <path d="M281.6 991.3c-13.8 0-25-11.2-25-25V45.8c0-13.8 11.2-25 25-25s25 11.2 25 25v920.5c0 13.8-11.2 25-25 25zM725.9 463.1H500.1c-13.8 0-25-11.2-25-25s11.2-25 25-25h225.8c13.8 0 25 11.2 25 25s-11.2 25-25 25zM725.9 667.1H500.1c-13.8 0-25-11.2-25-25s11.2-25 25-25h225.8c13.8 0 25 11.2 25 25s-11.2 25-25 25zM776.9 565.1H449.1c-13.8 0-25-11.2-25-25s11.2-25 25-25h327.8c13.8 0 25 11.2 25 25s-11.2 25-25 25z" fill="#707070" p-id="17827"></path>
                            </svg>
                        </div>
                        <span style="font-size: 12px;color: #444444;">游戏攻略</span>
                    </van-grid-item>

                    <van-grid-item @click="openAutoClickPage" v-show="autoClickShow">
                        <div class="menu-img-view">
                            <svg t="1759378442378" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4216" width="22" height="22"><path d="M150.1184 150.1184C250.2656 50.0736 370.8928 0 512 0c141.1072 0 261.7344 50.0736 361.8816 150.1184C973.9264 250.2656 1024 370.8928 1024 512c0 141.2096-50.0736 261.8368-150.1184 361.8816C773.7344 973.9264 653.1072 1024 512 1024c-141.1072 0-261.7344-50.0736-361.8816-150.1184C50.0736 773.8368 0 653.2096 0 512 0 370.8928 50.0736 250.2656 150.1184 150.1184zM512 41.8816c-85.2992 0-164.1472 20.8896-236.3392 62.7712C203.4688 146.432 146.432 203.4688 104.6528 275.6608 62.7712 347.9552 41.8816 426.7008 41.8816 512c0 129.6384 45.9776 240.4352 137.8304 332.288C271.5648 936.2432 382.3616 982.1184 512 982.1184c129.6384 0 240.4352-45.8752 332.288-137.8304C936.2432 752.4352 982.1184 641.6384 982.1184 512c0-129.6384-45.9776-240.3328-137.8304-332.288C752.4352 87.7568 641.6384 41.8816 512 41.8816zM512 256c-36.1472 0-70.144 7.0656-102.1952 20.8896C377.856 290.9184 349.4912 309.3504 324.9152 332.288c-22.9376 24.576-41.472 52.9408-55.3984 84.8896S248.6272 483.328 248.6272 519.3728c0 36.1472 6.9632 70.144 20.8896 102.1952s32.4608 60.3136 55.3984 84.8896C349.4912 729.4976 377.856 747.9296 409.8048 761.856 441.856 775.7824 475.8528 782.7456 512 782.7456c36.1472 0 70.144-6.9632 102.1952-20.8896C646.144 747.9296 674.5088 729.4976 699.0848 706.4576c22.9376-24.576 41.472-52.9408 55.3984-84.8896s20.8896-66.048 20.8896-102.1952c0-36.0448-6.9632-70.144-20.8896-102.1952S722.0224 356.9664 699.0848 332.288C674.5088 309.3504 646.144 290.9184 614.1952 276.8896 582.144 263.0656 548.1472 256 512 256z" p-id="4217" fill="#7c7b84"></path></svg>
                        </div>
                        <span style="font-size: 12px;color: #444444;margin-top: 5px;">连点器</span>
                    </van-grid-item>

                    <van-grid-item @click="openWeixinPage">
                        <div class="menu-img-view">
                            <img src="../../img/menu/wechat.png" style="width: 30px;height: 30px;">
                        </div>

                        <span style="font-size: 12px;color: #444444;">绑定微信</span>
                    </van-grid-item>
                    <van-grid-item @click="openRechargePage">
                        <div class="menu-img-view">
                            <img src="../../img/menu/chong.png" style="width: 30px;height: 30px;">
                        </div>

                        <span style="font-size: 12px;color: #444444;">充值加币</span>
                    </van-grid-item>
                    <van-grid-item @click="openBindTelPage">
                        <div class="menu-img-view">
                            <img src="../../img/menu/phone.png" style="width: 26px;height: 24px;">
                        </div>
                        <span style="font-size: 12px;color: #444444;">绑定手机</span>
                    </van-grid-item>
                    <van-grid-item @click="openPasswordPage">
                        <div class="menu-img-view">
                            <img src="../../img/menu/password2.png" style="width: 26px;height: 26px;">
                        </div>

                        <span style="font-size: 12px;color: #444444;">修改密码</span>
                    </van-grid-item>
                    <!--<van-grid-item @click="goPage('app')" v-if="from === 'android'">
                        <div class="menu-img-view">
                            <img src="../../img/menu/qili-logo.png" style="width: 24px;height: 24px;border-radius: 3px;">
                        </div>

                        <span style="font-size: 12px;color: #444444;">七里APP</span>
                    </van-grid-item>-->

                    <van-grid-item v-if="gameSpeedEnable" @click="openGameSpeedPage">
                        <div class="menu-img-view">
                            <svg t="1720250938331" style="width: 22px;height: 22px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1547" width="40" height="40"><path d="M166.32 808.98l-99.28 99.28c-15.31 15.32-39.71 15.32-55.03 0-15.32-15.31-15.32-39.71 0-55.03l98.71-99.28c15.32-15.31 39.71-15.31 55.03 0 15.32 15.32 15.32 39.72 0.57 55.03z m48.22 48.79l-99.28 99.27c-15.31 15.32-15.31 39.71 0 55.03 15.32 15.32 39.71 15.32 55.03 0l99.28-99.28c15.32-15.32 15.32-39.71 0-55.03-15.32-15.31-39.72-15.31-55.03 0.01z m625.14-545.16c0 71.47-57.86 129.34-129.34 129.34S581 384.08 581 312.61c0-71.48 57.86-129.34 129.34-129.34 72.05 0 129.91 57.86 129.34 129.34z m-77.71 0.57c0-28.36-23.26-51.63-51.62-51.63-28.36 0-51.62 23.26-51.62 51.63 0 28.36 23.26 51.62 51.62 51.62 28.93 0 52.19-23.26 51.62-51.62z m236.56 68.07c-27.8 104.39-83.39 203.65-164.51 285.35h-3.97l-5.11 5.67c10.21 38.57 11.35 78.28 2.84 116.86-9.07 46.52-32.33 90.2-66.94 124.8l-2.27 2.27c-38.57 36.87-85.09 59.57-134.45 67.51-51.62 7.94-105.51 0-152.6-23.26-17.58-10.21-25.53-32.9-16.45-51.63 1.7-2.84 3.41-5.67 5.67-8.5 14.18-15.32 24.96-32.9 32.9-51.63l3.4-7.94c-10.21 1.7-20.42 4.53-30.63 5.1-29.5 4.54-60.14 6.24-90.2 5.67-10.21 0-19.86-3.97-26.1-11.35L181.63 671.14c-8.51-7.95-11.35-18.72-10.78-29.5 0-28.37 2.27-58.43 5.67-86.79 1.7-10.78 2.84-20.99 5.1-31.2l-8.51 3.4c-17.58 7.95-35.17 18.72-51.06 33.47-14.75 14.18-39.14 12.48-53.32-2.27-2.27-2.84-3.97-7.37-6.24-10.21-23.26-47.09-30.63-99.28-22.69-150.9 8.22-51.8 32.65-99.66 69.78-136.71 34.61-34.61 78.85-57.86 123.67-66.94 39.14-8.51 79.42-7.94 116.86 2.27l7.95-7.95C439.75 106.69 538.45 51.66 642.83 23.3c108.35-28.36 222.38-28.36 329.59 0 13.62 4.54 23.82 15.32 27.23 27.23l0.57 0.57v0.56c28.37 107.78 28.37 221.81-1.69 329.59zM936.12 92.51c-89.06-19.86-182.67-18.16-270.03 5.1-91.34 24.96-178.7 73.18-250.74 145.22l-10.78 10.78-10.21 11.35c-10.21 11.35-26.66 16.45-42.55 10.78-31.2-12.48-65.81-14.75-98.71-7.38-31.2 6.81-61.27 22.13-86.23 46.52-26.66 27.8-43.12 60.7-48.79 95.3-3.4 20.99-3.4 42.55 0.57 62.97 9.64-5.67 18.72-10.78 28.93-14.18 26.66-11.34 55.6-18.15 84.53-18.72 3.97-0.57 7.94 0 11.91 0.56 19.86 5.67 31.77 26.66 26.1 46.52-7.95 26.1-13.05 52.2-16.45 78.29-1.7 22.12-3.4 43.12-3.97 64.67l146.36 146.93c22.12-1.14 43.11-2.27 64.67-5.11 27.23-3.97 52.76-8.51 78.29-15.89 3.97-0.56 7.94-1.13 11.91-1.13 20.42 0.57 36.31 18.72 36.31 39.14-1.7 29.5-7.38 58.43-19.29 85.66-3.97 9.08-9.07 19.29-14.18 28.36 20.42 3.97 41.98 3.97 62.4 1.13 33.47-5.1 66.94-20.99 93.03-47.09l1.13-1.13c24.39-24.96 39.71-55.6 47.09-86.79 6.81-32.34 3.97-66.94-7.94-99.28-4.54-14.18-1.7-30.64 10.21-41.41l11.91-11.35 8.51-8.51 2.27-1.13c72.04-72.61 119.7-159.41 145.79-250.17 23.27-89.05 25.54-180.95 7.95-270.01z" p-id="1548" fill="#ed441b"></path></svg>
                        </div>

                        <span style="font-size: 12px;color: #444444;">游戏加速</span>
                    </van-grid-item>

                    <van-grid-item @click="openChatPage">
                        <div class="menu-img-view">
                            <svg t="1720251406687" style="width: 26px;height: 26px;" class="icon" viewBox="0 0 1280 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7600" width="64" height="64"><path d="M1070.740917 430.002051m29.008131 0l151.267988 0q29.008132 0 29.008132 29.008131l0 0q0 29.008132-29.008132 29.008132l-151.267988 0q-29.008132 0-29.008131-29.008132l0 0q0-29.008132 29.008131-29.008131Z" fill="#4aa7f0" p-id="7601"></path><path d="M1002.761301 174.400148m24.328266-15.798961l126.86401-82.386451q24.328266-15.798961 40.127227 8.529305l0 0q15.798961 24.328266-8.529306 40.127228l-126.864009 82.38645q-24.328266 15.798961-40.127227-8.529305l0 0q-15.798961-24.328266 8.529305-40.127227Z" fill="#4aa7f0" p-id="7602"></path><path d="M1007.31223 754.149778m14.505978-25.23686l0 0q14.505978-25.23686 39.742838-10.730883l131.595762 75.640361q25.23686 14.505978 10.730883 39.742838l0 0q-14.505978 25.23686-39.742838 10.730882l-131.595763-75.64036q-25.23686-14.505978-10.730882-39.742838Z" fill="#4aa7f0" p-id="7603"></path><path d="M559.63978 687.53731H231.978764C104.095617 687.53731 0 583.484839 0 455.6736s104.095617-232.02191 231.978764-232.02191h327.661016v62.445865H231.978764a169.518518 169.518518 0 1 0-3.120855 339.008272h330.781871z" fill="#4aa7f0" p-id="7604"></path><path d="M344.1282 264.524824h58.016264v382.12497h-58.016264zM506.844117 225.852109h58.016264v459.470401h-58.016264zM332.723417 1024h-71.621466c-35.55186 0-64.473701-32.502914-64.473701-72.44123V678.390472h62.431482v273.168298c0 6.169801 2.675019 9.750874 3.638601 10.369293l70.025084-0.359546c-0.6328-0.258873 2.042219-3.839946 2.042218-10.067274V678.390472h62.431483v273.168298c0 39.938315-28.921841 72.44123-64.473701 72.44123z" fill="#4aa7f0" p-id="7605"></path><path d="M934.214295 911.174618a42.153116 42.153116 0 0 1-21.572731-6.069128l-396.7369-234.423674 31.75506-53.80239 362.119858 213.972725V80.653249L546.883106 297.473575 514.869173 243.843766 912.598419 6.212946c12.943638-7.766183 27.972641-8.29831 40.269097-1.323127S972.211064 24.923695 972.211064 40.038988v831.096642c0 15.08653-7.19091 28.217132-19.386694 35.163551a37.392733 37.392733 0 0 1-18.610075 4.875437z" fill="#4aa7f0" p-id="7606"></path></svg>
                        </div>
                        <span style="font-size: 12px;color: #444444;">游戏喊话</span>
                    </van-grid-item>
<!--                    <van-grid-item @click="toGcGamePage">
                        <div class="menu-img-view">
                            <svg t="1720337575251" style="width: 24px;height: 24px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13988" width="64" height="64"><path d="M383.488 73.142857l325.778286 429.275429 191.488-82.066286a18.285714 18.285714 0 0 1 22.674285 7.094857l46.226286 73.654857a18.285714 18.285714 0 0 1-2.56 22.674286l-144.091428 144.091429 154.404571 154.477714v142.774857a18.285714 18.285714 0 0 1-12.507429 12.434286l-142.628571-0.073143-154.331429-154.404572-144.237714 144.091429a18.285714 18.285714 0 0 1-22.674286 2.56l-73.654857-46.299429a18.285714 18.285714 0 0 1-7.094857-22.674285l82.066286-191.488L73.142857 383.488V91.428571a18.285714 18.285714 0 0 1 14.116572-17.773714L91.428571 73.142857h292.059429z m372.370286 662.016l-20.699429 20.699429 127.268572 127.268571h20.699428v-20.626286l-127.268571-127.268571zM337.115429 168.228571H168.228571v168.96l450.340572 342.308572-43.739429 102.180571 206.774857-206.848-102.180571 43.812572L337.188571 168.228571z" fill="#36ab60" p-id="13989"></path></svg>
                        </div>
                        <span style="font-size: 12px;color: #444444;">小游戏</span>
                    </van-grid-item>-->
                    <van-grid-item @click="openTradePage">
                        <div class="menu-img-view">
                            <svg t="1720336802915" style="width: 26px;height: 26px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9792" width="64" height="64"><path d="M955.9 719.5c-1.9-3.2-19.4-32.1-55.9-54.7-19.4-12-46.4-23.4-80.7-25.9 20-21.6 37.3-45.8 51.2-71.8 26.3-49.4 40.3-105.2 40.3-161.5 0-46.4-9.1-91.3-27-133.7-17.3-40.9-42.1-77.6-73.6-109.2-31.5-31.5-68.3-56.3-109.2-73.6-42.4-17.9-87.3-27-133.7-27-46.4 0-91.3 9.1-133.7 27-40.9 17.3-77.6 42.1-109.2 73.6s-56.3 68.3-73.6 109.2c-17.9 42.4-27 87.3-27 133.7 0 40.3 6.9 79.7 20.6 117.3 5.5 15.2 12.1 30 19.7 44.2H167l-53.2 0.6c-27.6 0.3-49.8 22.6-49.8 50v289.8c0 27.6 22.6 50 50.4 50h439.3l392.1-203.3c12.7-6.6 17.3-22.4 10.1-34.7zM359.8 198.1c55.4-55.4 129.1-86 207.5-86s152.1 30.5 207.5 86c55.4 55.4 86 129.1 86 207.5 0 48.1-11.9 95.8-34.4 137.9-21.8 40.8-53.4 76.4-91.5 103-4 2.8-8 5.5-12.2 8-24.4 9.4-63.4 29.1-96.6 46.6L339.6 591.4l0.3-0.2c-21-25.6-37.3-54.4-48.5-85.3-11.6-32.1-17.5-65.8-17.5-100.2-0.1-78.5 30.4-152.2 85.9-207.6zM114.4 882.5V642.3c0-13.7 11.1-24.8 24.9-25l27.8-0.3h38.7v290.4h-66.3c-13.8 0.1-25.1-11.1-25.1-24.9z m426.9 25H256.2V617h10.5l301.5 115.5c-1.6 0.9-2.7 1.5-3.1 1.7l-0.9 0.5-0.8 0.5c-0.7 0.4-67.4 40.5-229-2.9-13-3.5-26.5 3.9-30.5 16.8-4.1 13.5 3.7 27.8 17.3 31.5 74.1 20 139.9 26.4 195.8 19 44.3-5.8 67.7-18.7 73.3-22.2 8.5-4.8 112.6-62.6 153.3-77.4l0.1 0.2c0.3-0.2 0.5-0.3 0.8-0.5 0.2-0.1 0.3-0.1 0.5-0.2 48.3-17 90.9-14.8 126.5 6.5 9.5 5.7 17.3 12 23.5 17.9L541.3 907.5z" p-id="9793" fill="#4991f9"></path><path d="M465.1 515.8h77.2v81.6c0 12.5 11.2 22.7 25 22.7s25-10.2 25-22.7v-81.6h77.2c13.8 0 25-11.2 25-25s-11.2-25-25-25h-77.2v-53h77.2c13.8 0 25-11.2 25-25s-11.2-25-25-25h-32.8l34-69.8c6.1-12.4 0.9-27.4-11.5-33.4-12.4-6.1-27.4-0.9-33.4 11.5L581 362.8h-14.2l-58.1-94.9c-7.2-11.8-22.6-15.5-34.4-8.3-11.8 7.2-15.5 22.6-8.3 34.4l42.2 68.8h-43.1c-13.8 0-25 11.2-25 25s11.2 25 25 25h77.2v53h-77.2c-13.8 0-25 11.2-25 25 0 13.9 11.2 25 25 25z" p-id="9794" fill="#4991f9"></path></svg>
                        </div>
                        <span style="font-size: 12px;color: #444444;">交易平台</span>
                    </van-grid-item>


                    <!--<van-grid-item @click="close">
                        <div class="menu-img-view">
                            <img src="../../img/menu/ys.png" style="width: 24px;height: 24px;border-radius: 3px;">
                        </div>
                        <span style="font-size: 12px;color: #444444;">返回游戏</span>
                    </van-grid-item>-->

                    <van-grid-item @click="logout">
                        <div class="menu-img-view">
                            <img src="../../img/menu/logout.png" style="width: 20px;height: 20px;border-radius: 3px;">
                        </div>
                        <span style="font-size: 12px;color: #444444;">退出登录</span>
                    </van-grid-item>

<!--                    <van-grid-item @click="openFuliPage">
                        <div class="menu-img-view">
                            <img src="../../img/menu/xm45.png" style="width: 27px;height: 27px;">
                        </div>
                        <span style="font-size: 12px;color: #444444;">开区福利</span>
                    </van-grid-item>-->

                    <van-grid-item @click="openKfPage">
                        <div class="menu-img-view">
                            <img src="../../img/menu/kf2.png" style="width: 26px;height: 26px;">
                        </div>

                        <span style="font-size: 12px;color: #444444;">联系客服</span>
                    </van-grid-item>

                    <van-grid-item @click="openNewServer100Page">
                        <div class="menu-img-view">
                            <img src="../../img/menu/bs100.png" style="width: 27px;height: 27px;">
                        </div>
                        <span style="font-size: 12px;color: #444444;">开区福利</span>
                    </van-grid-item>

                </van-grid>

            </div>
        </div>

        <myloading v-show="showLoading"></myloading>
    </div>
</template>

<script>
    import {request} from '@/api/request'
    import {Dialog, Toast} from "vant";
    import myloading from '@/components/myloading'
    import '../../css/commonpage.css'

    import Vue from 'vue';
    import { Grid, GridItem } from 'vant';
    Vue.use(Grid);
    Vue.use(GridItem);

    export default {
        name: "main-menu",
        components: {
            myloading
        },
        data() {
          return {
              headerImg: '',
              userName: '',
              uid: '',
              tel: '',
              qlb: '0',
              serverMsg: '',
              showLoading: false,
              welfareCode: '',
              from: '',
              userInfo: {},
              gameJs: '',
              sdkVersion: '',
              gameSpeedEnable: false,
              autoClickShow: false,
          }
        },
        mounted() {
            this.gameSpeedEnable = localStorage.getItem('gameSpeedEnable') === 'true';
            this.autoClickShow = localStorage.getItem('androidAppVersion') === '3';
            this.initPage();
        },
        methods: {
            initPage() {
                let options = {
                    url:"/zfapp/getLoginInfo",
                    data: {}
                };
                request(options).then(res => {
                    this.showLoading = false;
                    if (res.data.success) {
                        this.userInfo = res.data.data;
                        this.qlb = parseFloat(this.userInfo.qlBalance);
                        this.userName = this.userInfo.userName;
                        this.uid = this.userInfo.userId;
                        this.headerImg = this.userInfo.headerImg || '';
                        this.serverMsg = this.userInfo.serverMsg;
                        if (this.userInfo.phone) {
                            this.tel = this.userInfo.phone;
                            localStorage.setItem('phone', this.userInfo.phone)
                        }

                        localStorage.setItem('tel', res.data.data.phone)
                        localStorage.setItem('headerImg', this.headerImg)
                    }
                    else {
                        Toast(res.data.error.message);
                    }
                });
            },
            close() {
                this.$parent.$parent.closeMainWindow();
            },
            openKf() {
                this.$parent.$parent.showKfPage();
            },
            openGiftPage() {
                this.$parent.$parent.openGiftPage();
            },
            openAutoClickPage() {
                this.close();
                this.$parent.$parent.openAutoClickPage();
            },
            openFuliPage() {
                this.$parent.$parent.openFuliPage();
            },
            openNewServer100Page() {
                this.$parent.$parent.openNewServer100Page();
            },
            openExpensePage() {
                this.$parent.$parent.openExpensePage();
            },
            openWeixinPage() {
                this.$parent.$parent.openWeixinPage();
            },
            openKfPage() {
                this.$parent.$parent.openKfPage();
            },
            openRechargePage() {
                this.$parent.$parent.openRechargePage();
            },
            openBindTelPage() {
                if (this.tel) {
                    this.$parent.$parent.openTelUnbindPage();
                }
                else {
                    this.$parent.$parent.openTelPage();
                }
            },
            openPasswordPage() {
                this.$parent.$parent.openPasswordPage();
            },
            openGameSpeedPage() {
                this.$parent.$parent.openGameSpeedPage();
            },
            openChatPage() {
                this.$parent.$parent.openChatPage();
            },
            openTradePage() {
                this.$parent.$parent.openTradePage();
            },
            toGcGamePage() {
                this.$parent.$parent.toGcGamePage();
            },
            openContentList(contentType){
                this.$parent.$parent.openContentListPage(contentType);
            },
            openContentView(contentId){
                this.$parent.$parent.openContentViewPage(contentId);
            },
            logout() {
                Dialog.confirm({
                    message: '确认要退出登录吗?',
                }).then(() => {
                    this.exit();
                })
                .catch(() => {
                });
            },
            exit() {
                this.$parent.$parent.logout();
            },
        }
    }
</script>

<style scoped>
    .all-view {
        box-sizing: border-box;
        overflow: hidden;
        max-width: 400px;
        margin: 0 auto;
    }
    .main-page-title {
        position: relative;
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0 10px;
        justify-content: flex-start;
        background-color: #4f6ed2;
    }
    .top-info-view {
        height: 50px;
        padding: 0 10px;
        margin-left: 10px;
        font-size: 12px;
        color: #ffffff;
        background-color: rgba(0,0,0,.1);
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
    }

    .main-body{
        display: flex;
        flex-direction: column;
        padding: 5px 10px;
        box-sizing: border-box;
        position: relative;
        height: 270px;
        background-color: #f8f8f8;
    }
    .menu-view {
        background-color: #ffffff;
        max-height: calc(100vh - 115px);
        overflow: hidden;
        overflow-y: auto;
        -ms-overflow-style: none;  /* IE 和 Edge */
        scrollbar-width: none;/* Firefox */
    }
    .menu-view::-webkit-scrollbar {
        display: none;/* 兼容 Chrome, Opera, 和 Safari */
    }



    .bottom-view {
        width: calc(100vw - 20px);
        max-width: 380px;
        background-color: #ffffff;
        color: #888888;
        margin-top: 5px;
        border-radius: 5px;
        font-size: 10px;
        padding: 0 10px;
        box-sizing: border-box;
        height: 35px;
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 5px;
        justify-content: space-between;
    }
    .menu-img-view {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .left-view {
        height: 230px;
        width: 32%;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 10px;
        position: relative;
    }
    .user-base-text {
        font-size: 12px;
        color: #666666;
        display: block;
    }
    .left-text {
        font-size: 10px;
        background: linear-gradient(0deg, #2bba06 4.248046875%, #03b134 49.0478515625%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .left-button {
        padding: 4px 14px;
        border-radius: 3px;
        font-size: 12px;
        color: #f3f3f3;
        background-color: #0263CC;
        user-select: none;
    }
    .exit-button {
        background-color: #EE3F14;
    }
    .right-view {
        flex: 1;
        position: relative;
        height: 230px;
    }
    .main-menu {
        padding: 5px;
        box-sizing: border-box;
        width: 60px;
        height: 50px;
        background-color: #F6A956;
        border-radius: 3px;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 13px;
        font-family: myFont,serif;
        color: #C32A1F;
    }
    .second-button {
        width: 100px;
        height: 35px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        font-family: myFont,serif;
        background-color: #ea7815;
        color: #ffffff;
    }
    .exchange-button {
        width: 60px;
        height: 26px;
        line-height: 26px;
        border: 2px solid #1558dc;
        color: #1558dc;
        font-family: myFont,serif;
        border-radius: 3px;

    }


    .back-input{
        flex: 1;
        height: 40px;
        display: flex;
        align-items: center;
    }
    .back-input .van-cell {
        padding: 1px 10px;
    }
    /deep/.back-input .van-field__control {
        color: #111111;
    }

    /deep/.van-grid-item__content {
        background-color: unset;
        padding: 12px 8px;
    }
</style>